import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.kyc_profile,
    (kyc_profile) => {
        return {
            kyc_profile
        }
    }
)